import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;
@Component({
  selector: 'app-view-geofence',
  templateUrl: './view-geofence.component.html',
  styleUrls: ['./view-geofence.component.css']
})

// 
export class ViewGeofenceComponent implements OnInit {
  public branchInformation: any = [];
  public searchInput: any = new Subject<string>();
  searchedValue: any = '';
  serchKey = 'branchName'
  noDataEnable: boolean = false;
  public geoFenceList: any = [];


  public cols = [
    { key: '#', display: '#' },
    {
      key: 'title', display: 'Title', headerConfig: { isDefault: true },
      subKey: 'compRating',
      config: {
        isComplaint: true,  // give complaint first
        isVehicle: true
      }
    }, {
      key: 'branchName', display: 'Branch ', headerConfig: { isDefault: true },
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
    // { key: 'model', display: 'Model', config: { isAttendance: true, } },
    {
      key: 'vehiclesData', display: 'Vehicles', headerConfig: { isDefault: true },
      subKey: 'compRating',
      config: {
        isComplaint: true,
        isVehicle: true
      }
    },
    {
      key: 'isEnable', display: 'Status', config: {
        isYesOrNo: true,
        title: {
          yesTitle: 'Active',
          noTitle: 'In Active'
        }
      },
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
          { display: 'Update', color: 'primary', icon: 'Edit', class: 'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' },
        ]
      }
    }
  ];

  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert) {
    this.getBranchList();
  }

  ngOnInit(): void {
    // this.getGeofenceList();
  }

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          res.data.filter((e) => {
            let option = { name: e.branchName, value: e.branchID };
            this.branchInformation.push(option);
          });
          this.getGeofenceList();
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getGeofenceList() {
    const obj = {
      // orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerGeofenceList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.tableDataProcess(res.data)
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  tableDataProcess(res) {
    res = res.map(data => {
      const branch = this.branchInformation.find(branch => branch.value == data.branch);
      if (branch) {
        return {
          ...data,
          branchName: branch.name
        };
      }
      return data;
    });
    this.geoFenceList = res.map((data: any) => {
      let obj = {
        title: data['title'] ? data['title'] : '',
        branchName: data['branchName'] ? data['branchName'] : '',
        isEnable: data['isEnable'] ? true : false,
        vehiclesData: this.formatVehicles(data.vehicles),
        geofenceID: data['geofenceID']
      }
      return obj;
    })
  }
  formatVehicles(vehicles) {
    if (vehicles && vehicles.length > 0) {
      if (vehicles.length == 1) {
        return vehicles[0];
      }
      else if (vehicles.length > 1) {
        return vehicles[0] + ` (+${vehicles.length - 1} ${vehicles.length == 2 ? 'other' : 'others'})`;
      }
    }
    return '';
  }
  onActionHandler(e: any) {
    const data = e.data;
    let view = 'view'
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/geofence/edit-geofence', e.data.geofenceID]);
    } else if (e.action.display.toLowerCase() == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("dwlwte data", e)
          this.deleteGeofenceData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/geofence/preview-geofence', e.data.geofenceID, view]);
    }
  }

  deleteGeofenceData(e?) {
    const obj = {
      geofenceID: e.data.geofenceID,
    };
    this.api.transportManagerGeofenceDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getGeofenceList();
      } else {
        Swal.fire({
          icon: res['status'].toLowerCase(),
          title: res['status'],
          text: res['message'],
        });
        // this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
